import { render, staticRenderFns } from "./MyNav.vue?vue&type=template&id=79dc0b47&scoped=true"
import script from "./MyNav.vue?vue&type=script&lang=js"
export * from "./MyNav.vue?vue&type=script&lang=js"
import style0 from "./MyNav.vue?vue&type=style&index=0&id=79dc0b47&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79dc0b47",
  null
  
)

export default component.exports